import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const AffiliateTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Read current URL
    const url = new URL(window.location.href);
    const refId = url.searchParams.get('ref');

    // No ref in URL → do nothing
    if (!refId) return;

    // Basic validation (prevents junk / abuse)
    // if (!/^[a-zA-Z0-9_-]{3,50}$/.test(refId)) return;

    // // Check existing cookie
    // const existingRef = document.cookie
    //   .split('; ')
    //   .find(c => c.startsWith('affiliate_ref='))
    //   ?.split('=')[1];

    // // If same ref already stored, do nothing
    // if (existingRef === refId) return;

    // Store / overwrite ref (last-click wins)
    const expiryDate = new Date();
    expiryDate.setDate(expiryDate.getDate() + 30);

    document.cookie = `affiliate_ref=${refId}; expires=${expiryDate.toUTCString()}; path=/; SameSite=Lax`;
  }, [location.search]); // ← runs on every route change

  return null; // this component renders nothing
};

export default AffiliateTracker;
